export var DayCellViewModel = /*#__PURE__*/function () {
  DayCellViewModel.create = function create(date, month, year, isWeekend) {
    return new DayCellViewModel(date, month, year, isWeekend);
  };

  function DayCellViewModel(date, month, year, isWeekend) {
    this.date = void 0;
    this.month = void 0;
    this.year = void 0;
    this.isWeekend = void 0;
    this.date = date;
    this.month = month;
    this.year = year;
    this.isWeekend = isWeekend;
  }

  return DayCellViewModel;
}();